module.exports = __webpack_public_path__ + "static/media/fl-cover-title.a218fdc3.png";